import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, translate, Utils } from 'versafleet-core';
import GlobalSearch from 'modules/globalSearch';
import HeaderProfileModule from 'modules/headerProfile';
import HeaderNotification from 'modules/notification/headerNotification';
import ReduxActions from 'reduxActions';
import withRouterHooks from 'utils/routerHelper';

const TITLEMENUITEM = [
  'MYJOBS',
  'Archives',
];

class Header extends React.Component {
  _loadNotificationItem = (notification) => {
    if (notification.category.includes('job')) {
      const id = notification.data.job.id;
      if (notification.category.includes('accepted')) {
        this.props.navigate(`/in_progress/jobs/${id}`);
      } else {
        this.props.navigate(`/submissions/jobs/${id}`);
      }
    } else {
      const id = notification.data.task.id;
      this.props.navigate(`/in_progress/tasks/${id}`);
    }
  }

  _loadFailedTaskItem(item) {
    this.props.dispatch(ReduxActions.filter.updateMyJobsTaskFilter({
      date: [item.date, item.date],
      state: ['failed'],
    }));
    this.props.navigate('/in_progress');
  }

  _loadGlobalSearchItem = (data) => {
    const { id } = data;
    if (data.guid.indexOf('JB') === -1) {
      if (!this.props.location.pathname.includes('archives')) {
        this.props.navigate(`${Utils.Router.getPath()}/tasks/${id}`);
      } else {
        this.props.navigate(`/archives/tasks/${id}`);
      }
    } else if (!this.props.location.pathname.includes('archives')) {
      this.props.navigate(`${Utils.Router.getPath()}/jobs/${id}`);
    } else {
      this.props.navigate(`/archives/jobs/${id}`);
    }
  }

  _renderLogo = () => (
    <div className="vf-header__logo-container">
      <img alt="versafleet-logo" src="/assets/images/versafleet.png" />
    </div>
  )

  _renderTitle() {
    return (
      <div className="vf-header__page-title">
        {this.props.title}
      </div>
    );
  }

  _renderActions() {
    const index = TITLEMENUITEM.indexOf(this.props.title);
    const { strings, account } = this.props;
    const profile = this.props.profile || {};

    return (
      <div className="vf-header__header-actions">
        <GlobalSearch
          onClickItem={item => this._loadGlobalSearchItem(item)}
        />

        <HeaderNotification
          onClickFailedTaskItem={item => this._loadFailedTaskItem(item)}
          onClickNotificationItem={item => this._loadNotificationItem(item)}
        />

        <HeaderProfileModule.Button
          activatorUser={account.name}
          content={[{
            iconClassName: 'versa-person',
            text: profile.contact_person,
          }, {
            iconClassName: 'versa-email',
            text: profile.email,
          }, {
            iconClassName: 'versa-call',
            text: profile.contact_number,
          }]}
          name={profile.name}
        />

        <Components.Menu
          selectedIndex={index}
        >

          <Components.Menu.Item
            iconClassName="versa-home"
            key="home"
            onClick={() => this.props.navigate('/submissions')}
            text={strings.home}
          />
          <Components.Menu.Item
            iconClassName="versa-archive"
            key="archive"
            onClick={() => this.props.navigate('/archives/tasks')}
            text={strings.archives}
          />
          <Components.Menu.Item
            iconClassName="versa-logout"
            key="logout"
            onClick={this.props.logout}
            text={strings.logout}
          />

        </Components.Menu>
      </div>
    );
  }

  render() {
    return (
      <div className="vf-header">
        {this._renderLogo()}
        {this._renderTitle()}
        {this._renderActions()}
      </div>
    );
  }
}

Header.displayName = 'Header';

Header.propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  logout: PropTypes.func.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    name: PropTypes.string,
    contact_name: PropTypes.string,
    contact_number: PropTypes.string,
    contact_email: PropTypes.string,
  }),
  strings: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired,
};

Header.defaultProps = {
  profile: null,
};

export default withRouterHooks(connect()(translate('Header')(Header)));
